module.exports = __webpack_public_path__ + "img/step-2-mobile.e66afbe1.gif";